module.exports = __webpack_public_path__ + "img/ground_2.933e5120.png";